// extracted by mini-css-extract-plugin
export default {"rowHasBadge":"mD-z","smallCardRow":"nD-z","largeCardRow":"oD-z","productSearchRow":"pD-z","curatedRow":"qD-z"};